export default __webpack_public_path__ + "static/media/0_Intro.ddec6848.mp4";